(function () {
  function getContainerFromTarget(target) {
    return target.closest('[data-custom-metafield]');
  }

  function setHiddenValue(container, value) {
    const input = container.querySelector('.custom-metafield-input');
    if (!input) return;
    input.value = value;
    input.setAttribute('value', value);
  }

  function syncToggle(container) {
    const radios = container.querySelectorAll('input[type="radio"]');
    const toggle = container.querySelector('.custom-metafield-toggle');

    if (!radios.length || !toggle) return;

    const checkedRadio = Array.from(radios).find((radio) => radio.checked) || radios[0];
    const checkedIndex = Array.from(radios).indexOf(checkedRadio);

    setHiddenValue(container, checkedRadio.value);

    toggle.classList.toggle('active', checkedIndex === 1);
    toggle.classList.toggle('is-on', checkedIndex === 1);
    toggle.setAttribute('aria-pressed', checkedIndex === 1 ? 'true' : 'false');
  }

  function syncPills(container) {
    const active = container.querySelector('.custom-metafield-pill.active');
    const first = container.querySelector('.custom-metafield-pill');
    const current = active || first;

    if (!current) return;

    container.querySelectorAll('.custom-metafield-pill').forEach((btn) => {
      btn.classList.remove('active');
    });

    current.classList.add('active');
    setHiddenValue(container, current.dataset.value || '');
  }

  function initCustomMetafields(scope) {
    const containers = scope.querySelectorAll('[data-custom-metafield]');

    containers.forEach((container) => {
      const type = container.dataset.type;

      if (type === 'pills') {
        syncPills(container);
      }

      if (type === 'toggle') {
        syncToggle(container);
      }
    });
  }

  function stopCustomEvent(event) {
    const container = getContainerFromTarget(event.target);
    if (!container) return;

    event.stopPropagation();
  }

  document.addEventListener(
    'click',
    function (event) {
      stopCustomEvent(event);

      const pill = event.target.closest('.custom-metafield-pill');
      if (!pill) return;

      event.preventDefault();

      const container = pill.closest('[data-custom-metafield][data-type="pills"]');
      if (!container) return;

      const pills = container.querySelectorAll('.custom-metafield-pill');
      pills.forEach((btn) => btn.classList.remove('active'));

      pill.classList.add('active');
      setHiddenValue(container, pill.dataset.value || '');
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      const toggle = event.target.closest('.custom-metafield-toggle');
      if (!toggle) return;

      stopCustomEvent(event);

      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();

      const container = toggle.closest('[data-custom-metafield][data-type="toggle"]');
      if (!container) return;

      const radios = container.querySelectorAll('input[type="radio"]');
      if (radios.length < 2) return;

      const secondChecked = radios[1].checked;
      radios[0].checked = secondChecked;
      radios[1].checked = !secondChecked;

      syncToggle(container);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const toggle = event.target.closest('.custom-metafield-toggle');
      if (!toggle) return;

      stopCustomEvent(event);
      event.preventDefault();

      const container = toggle.closest('[data-custom-metafield][data-type="toggle"]');
      if (!container) return;

      const radios = container.querySelectorAll('input[type="radio"]');
      if (radios.length < 2) return;

      const secondChecked = radios[1].checked;
      radios[0].checked = secondChecked;
      radios[1].checked = !secondChecked;

      syncToggle(container);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const radio = event.target.closest('[data-custom-metafield][data-type="toggle"] input[type="radio"]');
      if (!radio) return;

      stopCustomEvent(event);

      const container = radio.closest('[data-custom-metafield][data-type="toggle"]');
      if (!container) return;

      syncToggle(container);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    initCustomMetafields(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCustomMetafields(event.target);
  });
})();